import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import {
  MainKpiWidgetComponent,
} from '@uigy/modules/overview/kpis/kpi-main/main-kpi-widget/main-kpi-widget.component';
import { MainKpiICPConfigService } from '@uigy/modules/overview/kpis/kpi-main/services/main-kpi-icp-config.service';
import { MainKpiEMConfigService } from '@uigy/modules/overview/kpis/kpi-main/services/main-kpi-em-config.service';
import { IemService } from '@uigy/shared/services/iem.service';
import { MainKpiConfigTypes } from '@uigy/modules/overview/kpis/kpi.types';

@Component({
    selector: 'app-main-kpi-wrapper',
    imports: [
        MainKpiWidgetComponent,
    ],
    templateUrl: './main-kpi-wrapper.component.html',
    styleUrl: './main-kpi-wrapper.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainKpiWrapperComponent implements OnInit {
  public kpiConfigs = signal<MainKpiConfigTypes[]>([]);
  private mainKpiICPConfigService = inject(MainKpiICPConfigService);
  private mainKpiEMConfigService = inject(MainKpiEMConfigService);
  private iemService = inject(IemService);

  private readonly isEM = signal<boolean>(this.iemService.isIEM());

  public ngOnInit(): void {
    this.setInitialState();
  }

  private setInitialState(): void {
    this.kpiConfigs.set(
      this.isEM() ? this.mainKpiEMConfigService.getKpiConfigs() : this.mainKpiICPConfigService.getKpiConfigs()
    );
  }
}
